import { axios } from '../config/axios';

const endPoint = '/project/device/usb-approval-requests';

// status: 'pending' | 'decided' | 'all'
const getUsbApprovalRequests = async (status) => {
    return axios.get(endPoint, { params: { status } });
}

// status: 'approved' | 'rejected'; remark optional
const decideUsbApprovalRequest = async (requestId, status, remark) => {
    return axios.patch(`${endPoint}/${requestId}/decision`, { status, remark });
}

export { getUsbApprovalRequests, decideUsbApprovalRequest }
